import LanguageService from "./LanguageService";
// import mushroom from './mushroom.api.def';
import mushroom from "./api/trangvang-api";
import config from "../config.json";
import { blockUi, unblockUi } from "../shared/global";

window.requestCount = 0;

//let ApiService = {};

const LIST_METHOD = [
  "list",
  "getAll",
  "count",
  "findById",
  "create",
  "batchCreate",
  "update",
  "batchUpdate",
  "partialUpdate",
  "delete",
  "batchDelete",
];

let ApiService = (objData) => {
  if (window.requestCount == 0 && !objData.dontLoading) {
    blockUi();
  }
  window.requestCount += 1;

  if (objData.type && objData.type != "views") {
    let request;
    if (LIST_METHOD.indexOf(objData.type) !== -1) {
      request = mushroom[objData.module][objData.type + "Async"](
        objData.value,
        objData.params
      );
    } else {
      request = mushroom[objData.module][objData.type + "Async"]({
        body: objData.value,
        params: objData.params,
      });
    }
    return request
      .then((response) => {
        checkSuccess(response, objData);
        return response;
      })
      .catch((error) => {
        checkError(error, objData);
        throw error;
      });
  } else {
    return mushroom[objData.module].views[objData.viewAction + "Async"](
      objData.value,
      objData.params
    )
      .then((response) => {
        checkSuccess(response, objData);
        return response;
      })
      .catch((error) => {
        checkError(error, objData);
        throw error;
      });
  }
};

ApiService.clearCache = (url) => {
  mushroom.$cache.invalid(url);
};

function checkSuccess(res, objData) {
  window.requestCount -= 1;
  if (window.requestCount == 0) {
    unblockUi();
  }
  if (
    objData.message &&
    objData.message.success &&
    objData.message.success == "hidden"
  ) {
    return;
  }
  if (
    objData.message &&
    objData.message.success &&
    objData.message.success != "hidden"
  ) {
    toastr.success(objData.message.success);
  } else {
    if (objData.type == "create") {
      toastr.success(LanguageService.lang.c_addSuccess);
    } else if (objData.type == "partialUpdate") {
      toastr.success(LanguageService.lang.c_updateSuccess);
    } else if (objData.type == "delete") {
      toastr.success(LanguageService.lang.c_deleteSuccess);
    } else if (objData.type == "accept") {
      toastr.success(LanguageService.lang.c_approvedSuccess);
    } else if (objData.type == "batchDelete") {
      if (res.meta && res.meta.successIds && res.meta.successIds.length > 0) {
        toastr.success(
          LanguageService.lang.c_delete +
            " " +
            res.meta.successIds.length +
            " " +
            LanguageService.lang.c_recordSuccess
        );
      }
      if (res.meta && res.meta.failureIds && res.meta.failureIds.length > 0) {
        toastr.error(
          LanguageService.lang.c_delete +
            " " +
            res.meta.failureIds.length +
            " " +
            LanguageService.lang.c_recordError
        );
      }
    }
  }
}

function checkError(err, objData) {
  window.requestCount -= 1;
  if (window.requestCount == 0) {
    unblockUi();
  }
  if (
    objData.message &&
    objData.message.error &&
    objData.message.error == "hidden"
  ) {
    return;
  }
  if (
    objData.message &&
    objData.message.error &&
    objData.message.error != "hidden"
  ) {
    toastr.error(objData.message.error);
  } else {
    if (objData.type == "findById") {
      toastr.error(LanguageService.lang.c_findError);
    } else if (objData.type == "list") {
      toastr.error(LanguageService.lang.c_findError);
    } else if (objData.type == "create") {
      toastr.error(LanguageService.lang.c_addError);
    } else if (objData.type == "partialUpdate") {
      toastr.error(LanguageService.lang.c_updateError);
    } else if (objData.type == "batchDelete") {
      toastr.error(LanguageService.lang.c_deleteError);
    } else if (objData.type == "views") {
      toastr.error(LanguageService.lang.c_findError);
    } else {
      toastr.error(LanguageService.lang.c_findError);
    }
  }
}

ApiService.get = async (url, header) => {
  let headers = Object.assign(
    {
      Token: localStorage.getItem(
        "mushroom.tokens[" + config.hostApiTrangVang + "api/v1/" + "]"
      ),
    },
    header
  );
  let option = {
    method: "GET",
    headers: headers,
  };
  if (url.length > 1000) {
    option.method = "POST";
    option.headers["X-HTTP-Method-Override"] = "GET";
    option.headers["X-Override-QueryString"] = "true";
    let index = url.indexOf("?");
    option.body = url.substring(index);
    url = url.substring(0, index);
  }
  const respon = await fetch(url, option);
  return respon.json();
};

ApiService.post = async (url, header, body) => {
  let headers = Object.assign(
    {
      Token: localStorage.getItem(
        "mushroom.tokens[" + config.hostApiTrangVang + "api/v1/" + "]"
      ),
    },
    header
  );
  const respon = await fetch(url, {
    method: "post",
    headers: headers,
    body: JSON.stringify(body),
  });
  if (respon.ok) return respon.json();
  throw await respon.json();
};

ApiService.patch = async (url, data) => {
  const respon = await fetch(url, {
    method: "PATCH",
    headers: {
      Token: localStorage.getItem(
        "mushroom.tokens[" + config.hostApiTrangVang + "api/v1/" + "]"
      ),
    },
    body: JSON.stringify(data),
  });
  return respon.json();
};

ApiService.delete = async (url) => {
  const respon = await fetch(url, {
    method: "DELETE",
    headers: {
      Token: localStorage.getItem(
        "mushroom.tokens[" + config.hostApiTrangVang + "api/v1/" + "]"
      ),
    },
  });
  return respon.json();
};

export default ApiService;
